import React from "react";
import "./TiendaNube.css";
import TiendaNubeTable from "../components/TiendaNubeTable";

const TiendaNube = () => {
  return (
    <div className="mercadoshops-container">
      <div className="ms-header-container">
        <div>
          <h3>Productos</h3>
        </div>
      </div>

      {/* <div className="mercadoshops-navbar-buttons-container">
        <div className="mercadoshops-buttons-container"></div>
      </div> */}
      <div className="mercadoshops-table-container">
        <TiendaNubeTable />
      </div>
    </div>
  );
};

export default TiendaNube;
